import { render, staticRenderFns } from "./wechat-tips.vue?vue&type=template&id=6dea5643&scoped=true"
import script from "./wechat-tips.vue?vue&type=script&lang=ts"
export * from "./wechat-tips.vue?vue&type=script&lang=ts"
import style0 from "./wechat-tips.vue?vue&type=style&index=0&id=6dea5643&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea5643",
  null
  
)

export default component.exports